import React from 'react';
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import './styles.scss'

const ExecutiveMessage = (props) => {
  return (
    <StaticQuery
      query={graphql`
        query {
          allDataYaml {
            edges {
              node {
                top {
                  ceo {
                    heading
                    message
                    name
                  }
                }
                language
              }
            }
          }
          ceoImage: file(relativePath: {eq: "top/ceo.png"}) {
            name
            publicURL
            childImageSharp {
              fluid(maxWidth: 426) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      `}
      render={({ allDataYaml: { edges }, ceoImage}) => {
        const { language } = props
        const { node: { top: { ceo } } } = edges.find(({node}) => node.language === language)
        const { heading, message, name } = ceo

        return <div className="top-executive-message">
          <div className="executive-content-card d-xl-flex">
            <div className="executive-image">
              <img src={ceoImage.publicURL} loading="lazy" decoding="async" alt={ceoImage.name} />
            </div>
            <div className="executive-content flex-grow-1">
              <h4 className="text-center m-0">{heading}</h4>
              <div className="executive-msg">{message}</div>
              <div className="executive-name">{name}</div>
            </div>
          </div>
        </div>
      }}
    />
  )
}

export default ExecutiveMessage;
